import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { useRouteMatch } from 'react-router';
import { Route, Switch, useHistory } from 'react-router-dom';
import styled from 'styled-components';

import BagName from 'common/illustrations/BagName';

import DraftVenueEditor from './DraftVenueEditor/DraftVenueEditor';
import DraftVenueListPage from './DraftVenueListPage/DraftVenueListPage';

const BREAKPOINT = 1150;

const Root = styled.div`
  position: relative;
  flex: 1 1 auto;
  background-color: ${cbSemanticCssVars.surfaceMain};
  padding-block-end: max(32px, 7vw);
  @media (width < ${BREAKPOINT}px) {
    padding-block-end: min(40vw, 312px); /* leave space for background image */
  }
`;

const StyledBagName = styled(BagName)`
  position: absolute;
  bottom: -20px;
  left: -20px;
  width: 440px;
  @media (width < ${BREAKPOINT}px) {
    max-width: min(60vw, 440px);
  }
`;

const VenueDataCollectionRoot = () => {
  const { url, path } = useRouteMatch();
  const history = useHistory();
  return (
    <Root>
      <Switch>
        <Route path={`${path}/:venueId`}>
          <DraftVenueEditor
            onSaveSuccess={() => {
              history.push(url);
            }}
          />
        </Route>
        <Route path={path}>
          <DraftVenueListPage />
        </Route>
      </Switch>
      <StyledBagName />
    </Root>
  );
};

export default VenueDataCollectionRoot;
